import { motion } from 'framer-motion';

const PageLoader = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-primary"
    >
      <div className="flex flex-col items-center gap-6">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="text-3xl font-display font-bold text-white tracking-tight"
        >
          Xavier
          <span className="text-highlight">Agency</span>
        </motion.div>

        <div className="relative w-48 h-0.5 bg-white/10 rounded-full overflow-hidden">
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: '100%' }}
            transition={{ duration: 1.1, ease: 'easeInOut', repeat: Infinity }}
            className="absolute inset-y-0 left-0 w-1/2 bg-highlight"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default PageLoader;
